import { ViewModel,View } from "binder"
import { ChangeThemeMessage } from "../mainWindow/mainWindow-viewModel";
import { UserMainWindowViewModel } from "../userMainWindow/userMainWindow-viewModel";
import  { ThemeSelectorView } from "./themeSelector-view"

export class ThemeSelectorViewModel extends ViewModel{
    constructor(parentViewModel: UserMainWindowViewModel) {
        super(parentViewModel);
        this.typedParent = parentViewModel;
    }
    GetDefaultView(): View <ViewModel> {
        return new ThemeSelectorView();
    }
    public getTypeId(): string {
        return "VM-4C8F3A62-3D3C-48BE-9C38-9176566BF6FF"
    }
    private typedParent : UserMainWindowViewModel;
    setTheme1(){this.setBackground('1');}
    setTheme2(){this.setBackground('2');}
    setTheme3(){this.setBackground('3');}
    setTheme4(){this.setBackground('4');}
    setTheme5(){this.setBackground('5');}
    setTheme6(){this.setBackground('6');}
    setTheme7(){this.setBackground('7');}
    setTheme8(){this.setBackground('8');}
    setTheme9(){this.setBackground('9');}
    setTheme10(){this.setBackground('10');}
    setTheme11(){this.setBackground('11');}
    setTheme12(){this.setBackground('12');}
    setTheme13(){this.setBackground('13');}
    setTheme14(){this.setBackground('14');}
    setTheme15(){this.setBackground('15');}

    closeThemeWindow(){
        this.typedParent.closeThemeWindow();
    }

    setBackground(background:string){
        let msg = new ChangeThemeMessage()
        msg.background = background;
        msg.shallSave = true;
        this.handleMessage(msg);
    }
}
